import { Container, Icon, Message } from './styled';
import { BsFillMicFill, BsFillCameraFill } from 'react-icons/bs';
import { IoIosVideocam, IoMdContact } from 'react-icons/io';
import { IoLocationSharp, IoDocumentText } from 'react-icons/io5';
import { PiStickerFill } from "react-icons/pi";


export function LastMessage(props) {

  const { message } = props;

  const description = (contacts) => {
    const qtdContacts = contacts?.length;
    return (`
        ${contacts[0]?.contact_name}
        ${(qtdContacts > 1)
        ? ` e ${qtdContacts - 1} 
                ${(qtdContacts - 1 === 1)
          ? 'outro contato'
          : 'outros contatos'
        }`
        : ''
      }
    `);
  };


  const mountIcon = (type) => {
    switch (type) {
      case 'image':
        return <BsFillCameraFill />
      case 'voice':
        return <BsFillMicFill />
      case 'video':
        return <IoIosVideocam />
      case 'location':
        return <IoLocationSharp />
      case 'document':
        return <IoDocumentText />
      case 'sticker':
        return <PiStickerFill />
      case 'contacts':
        return <IoMdContact />
      default:
        return null
    }
  }

  const mountMessage = (message) => {
    if (message?.contacts) {
      return description(message.contacts)
    }
    if (message?.last_message) {
      return message.last_message
    }
    if (message?.body) {
      return message.body
    }
    return message.type
  }

  return (
    <Container>
      {(message.type !== 'text' && message.type !== 'template' && message.type !== 'info') &&
        <Icon>
          {mountIcon(message.type)}
        </Icon>
      }
      <Message>
        <p>
          {mountMessage(message)}
        </p>
      </Message>
    </Container>
  );
}